import React from 'react';

import { useAppSecondaryNavigation } from '@futrli/predict';
import { useRouteIds } from '@futrli/predict/hooks/useRouteIds';
import { useWorkspaceOrganisationSelector } from '@futrli/shared-services';
import { SecondaryNavbar } from '@futrli/ui-components/components/nav/secondary-navbar/secondary-navbar';

import { CreateEntityMenu } from './create-entity-menu/create-entity-menu';
import { SyncDataButton } from './sync-data/sync-data-button';

interface AppNavbarSecondaryContentProps {
  displayGlobalNav: boolean;
}

export const AppNavbarSecondaryContent = ({ displayGlobalNav }: AppNavbarSecondaryContentProps) => {
  const { menuItems, rightSideItems } = useAppSecondaryNavigation();
  const { workspaceId, organisationId, isConsolidation } = useRouteIds();
  const organisation = useWorkspaceOrganisationSelector(workspaceId, organisationId);
  const canAccessOrganisation = organisation?.can_be_accessed === true;
  const canDisplayCreateEntityMenu = isConsolidation || canAccessOrganisation;

  return (
    <SecondaryNavbar
      leftMenuItems={menuItems}
      rightMenuItems={rightSideItems}
      rightExtraContent={
        canDisplayCreateEntityMenu ? (
          <>
            <CreateEntityMenu />
            {canAccessOrganisation ? <SyncDataButton /> : null}
          </>
        ) : null
      }
      marginTop={displayGlobalNav}
    />
  );
};
